import store from '@/store'
import {API, PROJ_PFX} from '@/constants'

export interface AuthData {
  auth: string
  password: string
}

export function isAuthenticated () {
  return readToken()
}

export function readToken () {
  return localStorage.getItem(PROJ_PFX + 'token')
}

export function clearToken () {
  return localStorage.removeItem(PROJ_PFX + 'token')
}

export function setToken (token: string) {
  return localStorage.setItem(PROJ_PFX + 'token', token)
}

export function readRefreshToken () {
  return localStorage.getItem(PROJ_PFX + 'ref_token')
}

export function setRefreshToken (token: string) {
  return localStorage.setItem(PROJ_PFX + 'ref_token', token)
}

export function clearRefreshToken () {
  return localStorage.removeItem(PROJ_PFX + 'ref_token')
}

const api = {
  isAuthenticated,
  readToken,
  clearToken,
  setToken,
  setRefreshToken,
  readRefreshToken,
  clearRefreshToken
}

export default api